import React, { useRef, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Upload, Loader2 } from "lucide-react";

// URL input + direct file upload (PNG/JPG/SVG/WebP/GIF) to the tenant's object storage.
export function MediaInput({ value, onChange, placeholder = "https://…/image.png", testid = "media-input" }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div className="flex gap-1.5 items-center">
      <Input data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder} className="bg-[color:var(--surface)] flex-1 min-w-0 h-8 text-xs" />
      <input ref={fileRef} type="file" accept=".png,.jpg,.jpeg,.svg,.webp,.gif" className="hidden"
        onChange={(e) => upload(e.target.files?.[0])} />
      <Button data-testid={`${testid}-upload`} size="icon" variant="outline" disabled={busy}
        title="Upload an image" onClick={() => fileRef.current?.click()}
        className="h-8 w-8 shrink-0 bg-[color:var(--surface)]">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}
      </Button>
    </div>
  );
}
